import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ba72675e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ba72675e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba72675e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba72675e')) {
      api.createRecord('ba72675e', component.options)
    } else {
      api.reload('ba72675e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ba72675e&scoped=true&", function () {
      api.rerender('ba72675e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-renderer/exam/QuestionDirectFillGroup/index.vue"
export default component.exports